import * as React from 'react';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CookieConsent from 'react-cookie-consent';
import { DRAWER_CONTENTS, ROUTES } from '../../../const';
import { CONTEXT_PATH, NETEX_INFRA, GTM_ID } from '../../../config_module';
import * as drawerActions from '../../../actions/drawerActions';
import * as cookiesActions from '../../../actions/cookiesActions';
import TagManager from 'react-gtm-module';
import * as cookieUtils from '../../../utils/cookieUtils';
import _ from 'lodash';
import cookiesSVG from '../../../images/cookies.svg';
import { isElectronApp } from '../../../services/crossPlatform/crossPlatformService';
import { initCalendar } from '../../../utils/google/GCalendarUtils';
import { openCookiesDetail } from '../../../electron/windowManager';

const cookiesStyle = {
  height: '50%',
  width: '100%',
  overflowY: 'auto',
  background: 'rgb(18, 171, 227, 0.8)',
  flexWrap: 'nowrap'
};

const cookieLinkStyle = {
  fontWeight: 'bold',
  color: 'white',
  textDecoration: 'underline'
};

const buttonStyle = {
  backgroundColor: '#fff',
  color: '#12abe3',
  fontSize: '1.25rem',
  fontWeight: 'bold',
  maxWidth: '18.666rem',
  height: '4rem',
  width: '12rem'
};

class CookieConsentComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cookieName: 'CookieConsent'
    };
  }

  componentDidMount() {
    this.setState({ cookieName: `CookieConsent_${this.props.user._id}` });
  }

  onClickConfig = () => {
    this.props.drawerActions.openDrawerAndSetContent(DRAWER_CONTENTS.CREATE_COOKIES_PANEL);
  };

  setConsentCookie = () => {
    const { user } = this.props;
    cookieUtils.setConsentCookie(user, true);
    cookieUtils.setVideoCookie(user, true);

    if (NETEX_INFRA) {
      cookieUtils.setAnalyticsCookie(user, true);
      const tagManagerArgs = {
        gtmId: GTM_ID
      };
      TagManager.initialize(tagManagerArgs);
    }

    if (!_.isEmpty(this.props.googleMeetClientId) || !_.isEmpty(this.props.jitsiDomain)) {
      cookieUtils.setMeetCookie(user, true);
    }

    if (!_.isEmpty(this.props.googleMeetClientId)) {
      this.props.cookiesActions.toggleMeetCookie();
      initCalendar();
    }

    this.props.drawerActions.setDrawerClosed();
  };

  handleMoreInfoClick = () => {
    openCookiesDetail(this.props.cookiesInfoUrl);
  };

  showMoreInfoLink = () => {
    if (!isElectronApp()) {
      return (
        <a
          style={cookieLinkStyle}
          href={this.props.cookiesInfoUrl || ROUTES.COOKIES_DETAIL}
          rel="noopener noreferrer"
          target="_blank"
        >
          {I18n.t('panels.cookies.moreInfoLinkText')}
        </a>
      );
    }
    return (
      <a style={cookieLinkStyle} onClick={this.handleMoreInfoClick}>
        {I18n.t('panels.cookies.moreInfoLinkText')}
      </a>
    );
  };

  render() {
    return (
      <CookieConsent
        cookieName={this.state.cookieName}
        style={cookiesStyle}
        buttonStyle={buttonStyle}
        buttonWrapperClasses={'cookies-button'}
        contentClasses={'cookie-text'}
        onAccept={this.setConsentCookie}
        buttonText={I18n.t('panels.cookies.acceptAll')}
        overlay={true}
      >
        <img src={`${CONTEXT_PATH}${cookiesSVG}`} />
        <p
          ref={node => {
            if (node) {
              node.style.setProperty('font-size', '1.2rem', 'important');
              node.style.setProperty('line-height', '1.5rem', 'important');
            }
          }}
        >
          {this.props.platformName || I18n.t('panels.cookies.thisPlatform')}{' '}
          {I18n.t(NETEX_INFRA ? 'panels.cookies.promptTextFirstLine1' : 'panels.cookies.promptTextFirstLine1ADC')}
          &nbsp;{this.showMoreInfoLink()}&nbsp;{I18n.t('panels.cookies.promptTextFirstLine2')}
          <br />
          <br />
          {I18n.t('panels.cookies.promptTextSecondLine')}
          <a style={cookieLinkStyle} onClick={this.onClickConfig}>
            {I18n.t('panels.cookies.configLinkText')}
          </a>
          <br />
          <br />
          {NETEX_INFRA && I18n.t('panels.cookies.netex')}
        </p>
      </CookieConsent>
    );
  }
}

CookieConsentComponent.propTypes = {
  drawerActions: PropTypes.object,
  platformName: PropTypes.string,
  cookiesInfoUrl: PropTypes.string,
  googleMeetClientId: PropTypes.string,
  jitsiDomain: PropTypes.string,
  trackingIdGAnalytics: PropTypes.string,
  cookiesActions: PropTypes.object,
  user: PropTypes.object
};

function mapStateToProps(state) {
  return {
    googleMeetClientId: state.account.configuration.meetClientId,
    jitsiDomain: state.account.configuration.jitsiDomain,
    trackingIdGAnalytics: state.account.configuration.trackingIdGAnalytics,
    user: state.account.user
  };
}

function mapDispatchToProps(dispatch) {
  return {
    drawerActions: bindActionCreators(drawerActions, dispatch),
    cookiesActions: bindActionCreators(cookiesActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CookieConsentComponent);
